import { createReducer } from '@reduxjs/toolkit'
import * as authorizationsGroupsActions from '../actions/authorizationsGroups'
import { APIData, APIStatus } from '../axiosConfiguration'
import { AuthorizationsGroup } from '../type/authorizationsGroups'

type userManageState = {
  groupsList: APIData<AuthorizationsGroup[]>
}

const initialState: userManageState = {
  groupsList: { status: APIStatus.IDLE },
}

export default createReducer(initialState, (builder) => {
  builder
    .addCase(authorizationsGroupsActions.getAuthorizationsGroups.fulfilled, (state, action) => {
      state.groupsList.status = APIStatus.FULFILLED
      state.groupsList.data = action.payload
    })
    .addCase(authorizationsGroupsActions.getAuthorizationsGroups.rejected, (state, action) => {
      state.groupsList.status = APIStatus.REJECTED
      state.groupsList.error = action.payload
    })
    .addCase(authorizationsGroupsActions.getAuthorizationsGroups.pending, (state) => {
      state.groupsList.status = APIStatus.PENDING
    })
})
